interface OnboardingStepHeaderProps {
  step: number;
  totalSteps: number;
  title: string;
  subtitle: string;
}

export function OnboardingStepHeader({ step, totalSteps, title, subtitle }: OnboardingStepHeaderProps) {
  return (
    <div className="mb-7">
      <div
        style={{
          fontSize: 10,
          fontWeight: 600,
          letterSpacing: '0.08em',
          color: '#C2541A',
          textTransform: 'uppercase',
          marginBottom: 8,
        }}
      >
        Step {step} of {totalSteps}
      </div>
      <h2
        style={{
          fontSize: 22,
          fontWeight: 500,
          color: '#fff',
          lineHeight: 1.2,
          marginBottom: 8,
        }}
      >
        {title}
      </h2>
      <p
        style={{
          fontSize: 13,
          color: 'rgba(255,255,255,0.45)',
          lineHeight: 1.5,
        }}
      >
        {subtitle}
      </p>
    </div>
  );
}
